module.exports = __webpack_public_path__ + "Times_Education_Excellence_2024-16ffaa61.webp";